// extracted by mini-css-extract-plugin
export default {"time":"countdownTimer_time__qKvSk"};